import { DEFAULT } from "./default";

export const TEXT = {
  base: {
    empty: "Пусто",
    phoneLabel: "Телефон получателя",
  },
  buttons: {
    back: "Назад",
    bankPay: "Оплатить в приложении банка",
    cancel: "Отмена",
    checkPhone: "Отправить на проверку",
    chat: "Чат с поддержкой",
    copyLink: "Скопировать ссылку",
    createWithdraw: "Создать запрос",
    delete: "Удалить",
    getExchange: "Перейти к обмену",
    goTelegram: "Перейти в Telegram-бот",
    loadPhotoPassport: "Сделать фото паспорта",
    loadPhotoRegister: "Сделать фото регистрации",
    next: "Далее",
    out: "Вывести",
    ok: "Ок",
    pay: "Оплатить",
    selectPayments: "Выбрать способ оплаты",
    send: "Отправить на проверку",
    save: "Сохранить",
    withdraw: "Запросить вывод",
  },
  errors: {
    exchange: "Ошибка создания платежа (не установлено приложение банка)",
    withdraw: "Ошибка создания запроса",
    openTelegram: "Откройте приложение через телеграм",
  },
  errorPage: {
    title: "Сайт находится \n в разрабоке.",
    descriptions:
      " Для быстрого обмена \n и актуального курса \n перейдите в Telegram-бот.",
  },
  navbar: {
    history: "История",
    exchange: "Обмен",
    profile: "Профиль",
  },
  onboarding: {
    start: "Начать",
    secureExchange: "Ваш безопасный криптообменник",
    secureTransfers: {
      title: {
        part1: "Безопасные переводы",
        part2: "без блокировок по 115-ФЗ",
      },

      desc: "Мы используем защищённые методы для вашей безопасности.",
    },
    howItWorks: {
      title: "Как это работает",
      stepWord: "Шаг",
      steps: [
        "Мы открываем для вас рублёвый счёт в нашем банке-партнёре.",
        "Вы переводите рубли самому себе на счёт вашего кошелька.",
        "Отправляете рубли — получаете USDT или наоборот отправляете USDT и получаете рубли от себя же, на свой банковский счёт.",
      ],
      understand: "Понятно",
    },
    advantages: {
      title: "Преимущества:",
      list: [
        "Не нужно отчитываться перед налоговой",
        "Вы не покупаете у мошенников или с грязных карт",
        "Риск блокировки по 115-ФЗ сведён к минимуму.",
        "Риск обмана сведен к нулю.",
      ],
      go: "Перейти к обмену",
    },
  },
  history: {
    title: "История операций",
    desc: "Журнал операций по движению средств на ваших счетах",
    empty: "У вас пока что нет операций",
  },
  historyReferralPayments: {
    title: "История поступлений",
    desc: "Журнал поступлений по реферальной программе",
    empty: "У вас пока что нет поступлений",
  },
  historyWithdrawals: {
    title: "История выводов",
    desc: "Журнал выводов по реферальной программе",
    empty: "У вас пока что нет выводов",
  },
  drawerExchange: {
    title: "Детали операции",
    sent: "Отправлено",
    paymentType: "Способ оплаты",
    received: "Получено",
    wallet: "Кошелек получателя",
    commission: "Комиссия сервиса",
    commissionBlockChein: "Комиссия блокчейна",
    status: "Статус операции",
    dateAndTime: "Дата и время",
    close: "Закрыть",
    repeat: "Повторить",
    statusExchange: {
      ok: "Деньги отправлены",
      inProgress: "Ожидаем оплату",
      wait: "Деньги получены",
      error: "Отмена",
      return: "Запрошен возврат",
      returnOk: "Возврат",
    },
  },
  exchangeStatus: {
    notFound: "Заявка не найдена",
    youSend: "ВЫ ОТПРАВИТЕ",
    youGet: "ПОЛУЧИТЕ",
    rate: "Курс",
    network: "сеть TRC-20",
    banner: "Активный обмен · нажмите, чтобы открыть",
    pill: {
      wait: "Ожидает оплаты",
      // при продаже человек ничего не оплачивает, он присылает крипту
      waitSell: "Ожидаем перевод",
      run: "Идёт обмен",
      done: "Готово",
      fail: "Отменена",
    },
    pay: {
      lead: "Оплатите",
      bySbp: "по СБП",
      openBank: "Открыть банк для оплаты",
      comeBack: "После оплаты вернитесь в приложение",
      qrAlt: "QR-код для оплаты",
    },
    deposit: {
      lead: "Отправьте крипту одним переводом в сети TRC-20.",
      amount: "СУММА К ОТПРАВКЕ",
      address: "АДРЕС ПОЛУЧАТЕЛЯ",
      note: "Рубли уйдут по вашим реквизитам сразу после того, как перевод подтвердится в сети.",
    },
    buy: {
      paid: "Рубли отправлены",
      paidWaiting: "Ожидаем оплату",
      paidFail: "Оплата не прошла",
      paidDetail: "Платёж по СБП подтверждён.",
      paidPending: "Ждём подтверждение платежа.",
      sending: "Крипта отправляется на кошелёк",
      sent: "Крипта отправлена на кошелёк",
      sendingFail: "Крипта не отправлена",
      sendingLead: "На ваш адрес TRC-20:",
      credited: "Крипта зачислена",
      creditedLead: "Хеш транзакции:",
    },
    sell: {
      paid: "Крипта получена",
      paidWaiting: "Ожидаем ваш перевод",
      paidFail: "Перевод не получен",
      paidDetail: "Перевод в блокчейне подтверждён.",
      paidPending: "Ждём ваш перевод USDT.",
      sendLead: "Отправьте USDT на этот адрес TRC-20:",
      paidLead: "Хеш вашего перевода:",
      sending: "Рубли отправляются в банк",
      sent: "Рубли отправлены в банк",
      sendingFail: "Рубли не отправлены",
      credited: "Рубли зачислены",
      creditedDetail: "Деньги ушли по указанным реквизитам.",
    },
    failed: "Шаг не прошёл. Мы уже разбираемся, напишите нам, если нужно быстрее.",
    explorer: "Открыть в блокчейне ↗",
    support: {
      title: "Возникли проблемы?",
      description: "Напишите нам в телеграм — быстро ответим",
      message: "Здравствуйте! Нужна помощь по обмену.",
      operation: "Операция",
      code: "Код заявки",
      client: "Клиент",
      sent: "Отправлено",
      toReceive: "К получению",
      wallet: "Кошелёк",
      hash: "Хеш",
    },
  },
  profile: {
    title: "Профиль",
    desc: "Основная информация профиля и верификации учётной записи",
    titleWithdarw: "Запрос на вывод",
    descriptionsWithdraw:
      "Вывод будет произведён на указанный кошелёк за вычетом комисси сети 3 usdt в течении 24 часов",
    aboutProject: "О проекте",
    referralTitle: "Реферальная программа",
    referralLink: "Реферальный код ссылкой",
    notVerify: "верификация не нужна",
    referralBalance: "Баланс",
    buttons: {
      faq: "FAQ - Частые вопросы ",
      referral: "Реферальная программа",
      support: "Чат с поддержкой",
      privacyPolicy: "Политика конфиденциальности",
      termsOfUse: "Условия использования",
    },
  },
  faq: {
    title: "Что это за сервис?",
    desc: "«KASHA» - это телеграм-приложение для покупки и продажи USDT TRC20 через СБП любого РФ банка.",
    commonQuestions: {
      title: "Общие вопросы",
      one: {
        title: "Нужно ли получать смс на телефон?",
        answer:
          "Нет. Ваш номер телефона используется для идентификации последующих переводов. Мы никогда не отправляем смс на ваш номер - ни при регистрации, ни при верификации.",
      },
      two: {
        title: "В каких странах доступен сервис?",
        answer: "Мы работаем с гражданами РФ",
      },
      three: {
        title: "Я смогу сделать обмен, если нахожусь не в РФ?",
        answer: "Географических ограничений по месту нахождения клиента нет.",
      },
      four: {
        title:
          "Я смогу сделать обмен, если не могу принимать смс на свой телефон?",
        answer:
          "Да. Мы не используем SMS-подтверждения для покупки или продажи USDT TRC20.",
      },
      five: {
        title: "Можно ли менять данные после регистрации?",
        answer:
          "Да. После верификации вы можете изменить данные, написав в службу поддержки.",
      },
    },
    law: {
      title: "Могут ли мою карту заблокировать по 115-ФЗ / 161-ФЗ",
      one: {
        title: "115-ФЗ и 161-ФЗ",
        answer:
          "Закон 115-ФЗ обязывает банки контролировать операции и сделки своих клиентов, чтобы выявлять подозрительные. Его еще называют «антиотмывочным» законом. Название часто сокращают до ПОД/ФТ. \n Сервис «KASHA» и наши партнеры не используют для проведения операций дроповские карты, грязные криптокошельки или крипто-треугольники. Мы минимизируем риски, связанные с блокировкой по 115-ФЗ ваших карт, однако ваша карта может быть заблокирована, если вы превышаете по ней допустимые лимиты (в сумме). Например, мы не рекомендуем превышать лимит по движению средств более 100 000 рублей в день или 1 000 000 рублей в месяц. \n В нашем сервисе действует лимит в день и на разовую операцию - не более 100 000 рублей. \n В месяц - не более 500 000 рублей. \n Речь идет про все карты в сумме. \n \n Закон 161-ФЗ принят в 2011 году и регулирует работу национальной платежной системы России, то есть следит за тем, чтобы все безналичные расчеты между юридическими и физическими лицами были законными. По закону банки обязаны проверять, не занесены ли их клиенты или контрагенты клиентов в базу данных Центробанка. \n \n Сервис «KASHA» и наши партнеры не используют «грязных» контрагентов или рубли, происхождение которых вызывает вопросы.",
      },
    },

    registrationAndVerification: {
      title: "Легальность и законность",
      one: {
        title: "Это легальный сервис?",
        answer:
          "Покупка и продажа USDT TRC20 через сервис «KASHA» за рубли не нарушает закон. Вы не обязаны декларировать такие поступления и скрывать их. \n Все переводы осуществляются по модели me-to-me (самому себе).\n После прохождения KYC мы создаем для вас кошельковый счет. Это не полноценный банковский счет, а кошельковый, поэтому по нему не требуется уведомление налоговых органов РФ.\n При покупке крипты вы переводите рубли в пользу своего кошелькового счета.\n При продаже крипты рубли поступают с этого же кошелькового счета по типу c2c-операции от банка-партнера, но внутренняя система идентифицирует их как перевод самому себе.\n Все USDT TRC20 или рубли, которые вы получаете, чистые и не будут заблокированы. Мы регулярно проходим AML-проверки.",
      },
      two: {
        title: "Где юридически зарегистрирован сервис?",
        answer:
          "Расчетная небанковская кредитная организация \n РНКО «Очамчыра» (ООО) \n Адрес: 384820, Республика Абхазия, г. Очамчыра, ул. Б. Шинкуба, д. 63 \n Рег. номер: 111РА000651 \n ИНН/КПП: 11004691 / 611000107 \n Корр. счет: № 30103810000000000002 в Банке Абхазии \n БИК: 222400005",
      },
      three: {
        title: "Может ли мой РФ банк запросить пояснения по операции?",
        answer:
          "Такое право у банка есть всегда, однако операции выглядят как внутренние переводы самому себе, а не P2P-операции с третьими лицами. \n Если банк запросит подтверждение операций, вы можете ответить честно, что пополняли свой РУБЛЕВЫЙ кошелёк для личного пользования - дальнейших переводов и платежей. \n На вопрос «зачем?» лучше отвечать по сути, «как есть», в зависимости от целей переводов. \n Из документов вы можете скачать квитанцию по операциям + скрин операций из ЛК, где будут видны статусы и детали. \n Если банк просит доказать источник или движение средств, клиент берет справку или выписку в своем банке (по движению средств) и, при необходимости, показывает банку квитанцию из ЛК.",
      },
    },
    kys: {
      title: "KYC / Верификация",
      one: {
        title: "У меня не получается пройти верификацию",
        answer:
          "Обратите внимание, что в 99% случаев ошибки при прохождении верификации возникают из-за плохого качества фотографии и селфи.\n Мы крайне советуем для успешного прохождения верификации:\n \n - загружать четкие цветные фото российского паспорта (разворот с фото и страница с регистрацией) без бликов, теней и отражений, сделанные прямо, под 90°, при хорошем освещении; все поля документа должны быть полностью видны, особенно нижняя зона с машинно-читаемой строкой MRZ, именно она часто случайно обрезается и приводит к отказу;\n - не использовать скриншоты, фильтры или сжатие, не закрывать пальцами углы и не накладывать рамки; \n - селфи делать вживую, без очков, головных уборов, масок и наушников, с нейтральным выражением лица, на однотонном фоне, смотря в камеру; не использовать старые фото или селфи из галереи - проверка «на живость» чувствительна к таким ошибкам.\n Большинство клиентов успешно проходит верификацию, если соблюдает эти простые требования.",
      },
      two: {
        title: "Зачем проходить KYC (верификацию)?",
        answer:
          "Это требование законодательства РФ и Абхазии, которое гарантирует чистоту и прозрачность операций для всех сторон. \n \n Насколько безопасно передавать документы сервису? \n \n Мы не храним ваши документы и не передаем их третьим лицам. \n Обработкой документов занимается сертифицированный в РФ оператор - beorg.ru.",
      },
      three: {
        title: "Сколько времени занимает верификация?",
        answer:
          "Обычно до 15 минут.\n Если верификация не прошла: \n \n - попробуйте еще раз (количество попыток НЕ ограничено); \n - если не получается - напишите в службу поддержки, мы попробуем провести верификацию вручную.",
      },
      four: {
        title: "Как операция отображается в банковской выписке?",
        answer:
          "При получении рублей: \n  «Пополнение c2c от РНКО Очамчыра» - для банка это считается переводом самому себе. \n \n При покупке крипты: \n Вы отправляете рубли на счет РНКО Очамчыра.",
      },
    },
    exchange: {
      title: "Обмен, платежи и скорость",
      one: {
        title: "Как быстро мне начислят рубли / крипту?",
        answer: "Обычно 30 секунд, в редких случаях - до 10 минут",
      },
      two: {
        title: "Что делать, если прошло больше 10 минут, а поступления нет?",
        answer:
          "Напишите в службу поддержки. Мы оперативно разберемся и решим вопрос.",
      },
    },
    wallet: {
      title: "Кошельки и получатели",
      one: {
        title:
          "Я могу отправить крипту на сторонний кошелек (Binance / Bybit и пр.)?",
        answer:
          "Да.\n Мы не храним вашу крипту и не являемся кошельком. USDT зачисляется на тот кошелек, которым вы пользуетесь (Binance, Bybit и др.).",
      },
      two: {
        title: "Я смогу отправить рубли на карту друга или родственника?",
        answer:
          "Нет. \n Вы можете получать и отправлять рубли только на свои карты, зарегистрированные на ваше имя. \n Попытка отправки на сторонние карты приведет к срабатыванию антифрод-системы и блокировке операции. \n Мы оставляем за собой право ограничивать или блокировать клиентов, нарушающих это правило.",
      },
    },
    limit: {
      title: "Лимиты и комиссии",
      one: {
        title: "Есть ли комиссия за услуги сервиса?",
        answer: `Комиссия сервиса - ${DEFAULT.COMISSION_PERCENT_RUB_ALTUN}% + фиксированная комиссия блокчейна ${DEFAULT.COMISSION_USDT} USDT.`,
      },
      two: {
        title: "Какая минимальная сумма для обмена?",
        answer: `${DEFAULT.MIN_RUB} рублей или эквивалент в USDT TRC20. Обратите внимание, что если вы покупаете крипту, то из-за фиксированной комиссии в ${DEFAULT.COMISSION_USDT} USDT вам может прийти сумма значительно меньше, чем вы ожидаете. Рекомендуем менять суммы от ${DEFAULT.RECOMEND_AMOUNT} рублей и выше.`,
      },
      three: {
        title: "Какая максимальная сумма для обмена?",
        answer: `В нашем сервисе действует лимит в день и на разовую операцию - не более 100 000 рублей. \n В месяц - не более 500 000 рублей. \n Речь идет про все карты в сумме и эквивалент в USDT TRC20.`,
      },
    },
  },
  referral: {
    title: "Реферальная \n программа",
    desc: "Получай от 0.5% \n с обменов рефералов \n без верификации",
    descHighlight: ["0.5%", "без верификации"],
    titleHowItWorks: "Как это работает?",
    descHowItWorks:
      "Каждый приглашённый клиент \n закрепляется за партнёром пожизненно.\n Это означает, что вы получаете 0.5% \n с любых его обменов первого уровня \n и 0.1% с обменов второго уровня \n на постоянной основе, без ограничения \n по времени.",
    descHowItWorksHighlight: [
      "закрепляется за партнёром пожизненно.",
      "0.5%",
      "с любых его обменов первого уровня",
      "и 0.1% с обменов второго уровня",
    ],
    counts: "Перешли\n по ссылке, чел.",
    activeCounts: "Сделали\n обмены, чел.",
    exchangesCount: "Всего\n обменов",
    amount: "Начислено за\n все время, USDT",
    all: "все",
    history: "История поступлений",
    emptyHistory: "Здесь будут отображаться поступления на твой баланс",
    historyWithdrawals: "История выплат",
    emptyHistoryWithdrawals: "Здесь будут отображаться твои успешные выплаты",
    commonQuestions: {
      title: "Условия",
      one: {
        question: "Что такое реферальная программа KASHA?",
        answer:
          "Реферальная программа KASHA -  это двухуровневая партнёрская программа, которая позволяет зарабатывать процент с обменов пользователей, приглашённых вами в сервис. \n \n Вы получаете вознаграждение за каждый обмен приглашённых клиентов, а также дополнительный процент за обмены пользователей второго уровня.",
      },

      two: {
        question: "Как работает реферальная ссылка?",
        answer:
          "- Вы отправляете свою персональную реферальную ссылку клиенту или другу.\n - Клиент переходит по ссылке и нажимает «Запустить бот». \n - Когда приглашенный вами клиент нажмет кнопку «СТАРТ» в боте, вы получите уведомление о новой регистрации по вашей ссылке. \n - Если пользователь совершает обмен на любую сумму, вам начисляется партнёрское вознаграждение. \n \n Ваша реферальная ссылка автоматически доступна в разделе Профиль.",
      },
      three: {
        question: "Как начисляется вознаграждение?",
        answer: `Первый уровень \n \n Если пользователь, приглашённый вами напрямую, совершает обмен, вы получаете: \n ${DEFAULT.REFERRAL_LEVEL_1}% от общего оборота операции пользователя. \nВознаграждение считается от полной суммы обмена, уже включающей все комиссии и издержки сервиса. \n \n Начисление происходит с каждого обмена: \n - покупка USDT за рубли; \n - продажа USDT за рубли. \n \n Второй уровень \n \n Если ваш приглашённый пользователь делится своей ссылкой и приглашает нового клиента:\n пользователь, пригласивший напрямую, получает ${DEFAULT.REFERRAL_LEVEL_1}% от оборота; \n вы, как партнёр первого уровня, дополнительно получаете ${DEFAULT.REFERRAL_LEVEL_2}% от оборота.`,
      },
      four: {
        question: "Пожизненное закрепление клиентов",
        answer: `Ключевое отличие реферальной программы KASHA: \n \n Каждый приглашённый клиент закрепляется за партнёром пожизненно. \n Это означает, что вы получаете ${DEFAULT.REFERRAL_LEVEL_1}% с любых его обменов первого уровня и ${DEFAULT.REFERRAL_LEVEL_2}% с обменов второго уровня на постоянной основе, без ограничения по времени.`,
      },
      five: {
        question: "Могут ли приглашённые пользователи тоже зарабатывать?",
        answer: `Да. \n \n Пользователи, зарегистрировавшиеся по реферальной ссылке, полноценно участвуют в программе и получают: \n \n - ${DEFAULT.REFERRAL_LEVEL_1}% с обменов своих приглашённых пользователей; \n - ${DEFAULT.REFERRAL_LEVEL_2}% с обменов пользователей второго уровня. \n \n Вознаграждение для таких пользователей не уменьшается.`,
      },
      six: {
        question: "Нужно ли проходить верификацию для участия или выводе USDT?",
        answer: `Нет. \n \n Для участия в реферальной программе верификация не требуется. \n  Ваша реферальная ссылка доступна сразу после запуска бота в разделе Профиль.`,
      },
      seven: {
        question: "В какой валюте начисляется вознаграждение?",
        answer: `Партнёрское вознаграждение начисляется только в USDT. \n \n Выплата производится на криптокошелёк, который вы указываете при выводе. \n Адрес кошелька можно изменять по желанию партнёра перед каждым выводом.`,
      },
      eght: {
        question: "Как и когда происходят выплаты?",
        answer: `- Выплаты осуществляются один раз в неделю. \n - После запроса средства отправляются в течение 24 часов. \n \n Вывод производится в USDT.`,
      },
      nigth: {
        question: "Минимальная сумма и комиссии",
        answer: `- Минимальная сумма для вывода: ${DEFAULT.MIN_WITHDRAW_USDT} USDT. \n - При выводе удерживается фиксированная комиссия блокчейна 3 USDT. \n - Дополнительных комиссий нет.`,
      },
      teen: {
        question: "Где посмотреть статистику?",
        answer: `В боте отображается информация о: \n \n - количестве приглашённых пользователей; \n - начисленных вознаграждениях; \n - доступном балансе для вывода. \n \n Функционал находится в стадии бета-версии и будет постепенно расширяться.`,
      },
      eleven: {
        question: "Саморефералы и манипуляции",
        answer: `На текущий момент ограничения на саморефералов отсутствуют. \n \n Однако мы оставляем за собой право: \n \n - выявлять и отсекать самореферальные и манипулятивные схемы; \n - прекращать начисление вознаграждений по таким операциям в будущем.`,
      },
      twelve: {
        question: "Статус программы",
        answer: `Реферальная программа KASHA работает в бета-режиме. \n \n Мы можем: \n \n - изменять условия программы; \n - улучшать механику начислений; \n - расширять партнёрский функционал.`,
      },
      thirteen: {
        question: "Важное уведомление",
        answer: `Мы оставляем за собой право приостановить или полностью прекратить реферальную программу в любой момент и без объяснения причин.`,
      },
    },
    successReferralPayment:
      "Мы получиил ваш запрос на \n реферальный вывод. Деньги \n поступят в течении 24 часов. \n \n Спасибо, что помогаете нам \n развивать сервис!",
  },
  home: {
    descriptions: "Быстрые и безопасные переводы без риска блокировок",
  },
  exchange: {
    walletAddress: "Адрес кошелька получателя",
    sumPayment: "Сумма к переводу в USDT",
    stepOne: {
      title: "Детали обмена",
      descriptions: "Проверьте все необходимые данные \n перед оплатой",
    },
    stepTwo: {
      title: "Выбрать способ оплаты",
      descriptions:
        "Для обеспечения безопасности и \n требования законодательства",
    },
    stepThree: {
      title: "Выбрать Банк",
      titleBankGet: "Выбрать банк получения",
      descriptions:
        "Для оплаты по СБП у вас должно быть \n установлено банковское приложение. \n\n Пожалуйста, используйте только карты, оформленные на ваше имя.\n В противном случае платёж не пройдет.",
      descriptionsSpb:
        "Для оплаты по СБП у вас должно быть \n установлено банковское приложение. \n\n Пожалуйста, используйте только карты, оформленные на ваше имя.\n В противном случае платёж не пройдет.",
    },
    stepTwoPayment: {
      title: "Оплата",
      descriptions:
        "Переведите указанную сумму на адрес \n вашего расчётного счета у банк-партнёра,\n после чего деньги будут зачислены\n на ваш счёт.",
    },
    exchangeInfo:
      "Цена к получению указана \n с учётом всех комиссий \n и курса.",
    methodsPaymentsBuy: {
      one: { title: "Т Банк", descriptions: "В приложении банка" },
      two: { title: "ВТБ", descriptions: "В приложении банка" },
      three: { title: "СБП", descriptions: "В приложении банка" },
    },

    from: "Отдаю",
    to: "Получаю",
    phone: "Телефон получателя",
    amount: "Сумма",
    wallet: "Кошелек получателя",
    placeholderWallet: "Вставить адрес",
    scanWallet: "Наведите на QR-код кошелька",
    scanWalletError: "QR-код не распознан. Попробуйте ещё раз или вставьте адрес вручную.",
    walletNetwork: "Сеть",
    recentWallets: "Недавние адреса",
    walletWrongNetwork:
      "Похоже на адрес другой сети. Для обмена нужен адрес TRC-20 — он начинается с буквы T. По другой сети деньги не дойдут.",
    kys: "Необходимо будет пройти KYC",
    infoListExchange: {
      amountFrom: "Сумма к оплате",
      amountTo: "Сумма к получению",
      wallet: "Кошелек получателя",
      commission: "Комиссия сервиса",
      phone: "Телефон получателя",
      bank: "Банк получателя",
    },
  },
  notification: {
    copied: "Скопировано",
    errorWithdrawal: "Ошибка отправки запроса на вывод",
    successWithdraw: "Запрос создан, ожидайте",
    successWithdrawal: "Запрос на вывод отправлен успешно",
    pendingVerification: "Ожидайте результат",
    verificaion: "Вы верифицированы",
    moreBalance: "Запросили больше чем на балансе",
    minWithdraw: "Выводы от ",
    notValidWallet: "Не валидный адрес кошелька",
  },
  verificationPage: {
    title: "Верификация аккаунта",
    descriptions:
      "Для обеспечения безопасности\n и требования законодательства",
    processVerification: "Процесс верификации - ",
    statusVerification: {
      one: "Ожидаем отправку документов",
      two: "Документы отправлены",
      three: "Документы находятся \n на проверке",
      four: "Верификация аккаунта \n пройдена",
      five: "Отклонено: Попробуйте сделать еще раз с лучшим качеством фото и без бликов.",
    },
    statusVerificationProfile: {
      one: "Ожидаем отправку",
      two: "Документы отправлены",
      three: "На проверке",
      four: "Одобрено",
      five: "Отклонено.",
    },
    processingInformation:
      "Обработка информации может занять до одного\n часа. По результатам рассмотрения  заявки вам\n будет направлено уведомление.",
    stepVerification: {
      one: { title: "Номер телефона", descriptions: "Не зарегистрирован" },
      two: {
        title: "Фото паспорта",
        descriptions: "Сфотографируй главную \n и страницу регистрации",
      },
      three: { title: "Селфи", descriptions: "Сделайте четкое фото лица" },
    },
    titleRecomended: "Основные рекомендации",
    titleRecomendedHighlight: "рекомендации",
    verifyPhoto: "Правильное фото",
    falseVerifyTitle: "Частые ошибки",
    falseVerifyTitleHihtligth: "ошибки",
    verifyOnboarNotify:
      "Обращаем внимание, что проверка происходит автоматически, без указания точной причины отклонения, поэтому подробнее ознакомьтесь с примерами.",
    iLookedExamples: "Я ознакомился с примерами",
  },
  verificationPhonePage: {
    title: "Номер телефона",
    descriptions:
      "К данному номеру телефону будут \n привязаны все последующие транзакции",
  },
  verificationPassportPage: {
    title: "Фото вашего паспорта",
    descriptions: "Сфотографируй главный разворот \n и разворот с регистрацией",
  },
  verificationOnboardPassportPage: {
    title: "Приготовьте ваш паспорт",
    descriptions: "Ознакомьтесь с примерами как сделать \n правильное фото ",
  },
  withdrawal: {
    title: "Вывод средств",
    descriptions: "Минимальная сумма для вывода \n от 10 USDT.",
    withdrawalComission: "Комиссия сервиса",
    info: "При выводе удерживается \n фиксированная комиссия блокчейна \n 3USDT. Дополнительных комиссий нет.",
    titleDetails: "Детали операции",
    descriptionsDetails: "Проверьте все необходимые данные \n перед оплатой",
    details: {
      sumSend: "Сумма к отправке",
      comission: "Комиссия сервиса",
      sumGet: "Сумма к получению",
      wallet: "Кошелек получателя",
    },
  },
};
